import HLSVideoPlayer from './HLSVideoPlayer';

export default HLSVideoPlayer;
export * from './types';
export { HLSVideoPlayer };
